define('views/blocks/OrderSupportCenterModalView',['underscore','backbone','app','SubView',
        'models/SupportCenterModel',
        'template!blocks/support-center/order-modal',
        'template!blocks/support-center/order-form',
    ],
    function (_,Backbone,app,SubView,
              SupportCenterModel,
              SupportCenterOrderModalTemplate
    ) {

        var supportCenter ;
        function getSupportCenter(){
            if(!supportCenter) supportCenter = SupportCenterModel.getInstance();
            return supportCenter;
        }

        var OrderSupportCenterModalView = Backbone.View.extend(SubView).extend({
            className: 'order-support-center',
            overlay: 'transparent',
            events:{
                'click .close,.btn--close':'close',
                'click .btn--next':'clickNext',
                'click .btn--submit':'clickSubmit',
                'click .btn--prev':'clickPrev',
            },
            initialize:function(options){
                var view = this,
                section = getSupportCenter().getSection(options.sectionId),
                form = section.getForm();
                view.order = options.order;
                view.section = section;
                view.form = form;
                view.id_internal = section.getArticle().get('id_internal');
                view.step = 0;
                view.render();
                app.displayModal(view);
            },
            render:function(){
                var view = this;
                view.$el.html(SupportCenterOrderModalTemplate(view));
            },
            toggleSteps:function(){
                var view = this;
                var currentStepEl = view.$('.order-support-center__step:eq('+view.step+')');
                view.$('.order-support-center__step:not(:eq('+view.step+'))').removeClass('visible');
                currentStepEl.addClass('visible');
                view.$('.btn--prev').toggleClass('visible',!!currentStepEl.data('prev'));
            },
            clickNext:function(){
                var view = this;
                view.step ++;
                view.toggleSteps();
            },
            clickPrev:function(){
                var view = this;
                view.step --;
                view.toggleSteps();
            },
            clickSubmit:function(){
                var view = this,
                    form = view.$('form').get(0),
                    dataImage = false,
                    datas = {
                        order_product:[],
                        order_product_accompagnement:[],
                    },
                    btnSubmit = view.$('.btn--submit');

                function toggleButton(loading){
                    btnSubmit.attr('disabled',loading)
                        .toggleClass('loading',loading)
                }

                toggleButton(true);
                // validation & data collection
                _.each(form, function (el) {
                    //
                    //
                    //
                    var key = el.name,
                        value = el.value;
                    if(key){
                        switch(key){
                            case 'customer_upload':
                                var file = el.files[0];
                                if (file) {
                                    dataImage = new FormData();
                                    dataImage.append('image', file);
                                }
                                break;
                            case 'order_product':
                            case 'order_product_accompagnement':
                                el.checked && datas[key].push(value);
                               break;
                            case 'order_offered_products':
                                el.checked && (datas[key] = value);
                                break;
                            default:
                                datas[key] = value || '';
                                break;
                        }
                    }
                });
                if(!datas.customer_message){
                    app.banNotice(app.t('Le champs %s est requis','UI',app.t('description','OrderSupportCenter')));
                    toggleButton(false);
                    return
                }
                supportCenter.requestContactForm(datas,dataImage,onSuccess,onError)
                function onSuccess(){
                    view.clickNext();
                }
                function onError(message){
                    app.alert(message);
                    toggleButton(false);
                }
            },
            close:function(){
                this.trigger('close',this);
            },
        });

        return OrderSupportCenterModalView;
    }
);
